import { render, staticRenderFns } from "./EstadoPedido.vue?vue&type=template&id=36fef770&scoped=true&"
import script from "./EstadoPedido.vue?vue&type=script&lang=js&"
export * from "./EstadoPedido.vue?vue&type=script&lang=js&"
import style0 from "./EstadoPedido.vue?vue&type=style&index=0&id=36fef770&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fef770",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAvatar,VBtn,VChip,VContainer,VIcon,VImg,VProgressLinear})
